export default {
  id: 'virtual-capital',
  title: 'Virtual Capital & Paper Trading',
  content: `## Virtual Capital & Paper Trading

TradeLab gives every user **₹10,00,000 of virtual capital** to trade with. This is simulated money — nothing is connected to any real brokerage or bank account.

---

## How it works

When you place a trade:

1. The order is created in TradeLab's system
2. For **Market orders** — fills immediately at the last fetched price
3. For **Limit orders** — waits until the stock price reaches your limit price, then fills
4. Your cash balance reduces by the trade value
5. Your position appears under **Orders → Open Positions**

When you exit a trade, the P&L is calculated and your cash balance updates.

---

## Price Data

TradeLab fetches prices for NSE-listed stocks periodically throughout market hours. Prices are **not live streaming** — they update every few seconds via the backend feed.

> Do not expect tick-by-tick accuracy. TradeLab is a behavioural training tool, not a high-frequency trading simulator.

---

## Capital Top-Up

If your virtual capital drops significantly, you can reset or top-up from:

**Profile → Virtual Money Top-up**

This is for practice purposes. There is no penalty for topping up — the goal is learning, not a survival challenge.

---

## Capital Properties

| Property | Value |
|---|---|
| Starting capital | ₹10,00,000 |
| Currency | INR (virtual) |
| Exchange | NSE |
| Margin / Leverage | Not supported — full capital trades only |
| Overnight positions | Supported (Delivery / Swing trades) |
| Intraday auto-exit | 3:10 PM IST — all intraday positions force-closed |

---

## Example

> You have ₹10,00,000. You buy 100 shares of RELIANCE at ₹2,800.
> Trade value = ₹2,80,000. Cash balance becomes ₹7,20,000.
> RELIANCE moves to ₹2,870. You exit. P&L = +₹7,000.
> Cash balance becomes ₹7,27,000. Portfolio value = ₹10,07,000.`,
};
